import { render, staticRenderFns } from "./sectionM2.vue?vue&type=template&id=fcba4594&scoped=true&"
import script from "./sectionM2.vue?vue&type=script&lang=js&"
export * from "./sectionM2.vue?vue&type=script&lang=js&"
import style0 from "./sectionM2.vue?vue&type=style&index=0&id=fcba4594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba4594",
  null
  
)

export default component.exports